module.exports = __webpack_public_path__ + "f6fba229cc5cc5d953d48eefb14803c8.woff";